import React from "react";
import PropTypes from 'prop-types';
import { DrawerNavigator, NavigationState, } from  "~/native-ui"



export class Drawer extends React.PureComponent {
    static propTypes = {
        showDrawer: PropTypes.bool,
        appBar: PropTypes.node.isRequired,
        body: PropTypes.elementType.isRequired,
    }

    Body = () => {
        const { body: Body } = this.props;
        return (
            <React.Fragment>
                <NavigationState />
                <Body />
            </React.Fragment>
        );
    }

    get screens() {
        return [{
            name: "/",
            component: this.Body
        }]
    }
    
    render() {
        const drawerNavigatorProps = {
            screens: this.screens,
            drawerContent: this.props.appBar,
            showDrawer: this.props.showDrawer,
            isSmallScreen: this.props.isSmallScreen,
        }
        return (
            <DrawerNavigator { ...drawerNavigatorProps } />
        )
    }
}